// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"pf_a bih_qt bih_a bih_w","FaqAskQuestion__outdated":"pf_b bih_vr bih_xg"};